import React, { useState, useRef, useEffect } from 'react';
import {
    View,
    Text,
    TextInput,
    TouchableOpacity,
    TouchableWithoutFeedback,
    ScrollView,
    Keyboard,
    SafeAreaView,
    KeyboardAvoidingView,
    Platform,
    Alert,
    Modal,
    Image,
    Dimensions,
    useWindowDimensions,
    Linking,            // + add
    ActivityIndicator,  // + add
} from 'react-native';
import * as DocumentPicker from 'expo-document-picker';
import { Ionicons } from '@expo/vector-icons';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
import Svg, { Path } from 'react-native-svg';
import Checkbox from 'expo-checkbox';

import { useLogScreen } from '../../../useLogScreen';

const { width, height } = Dimensions.get('window');

const BackArrowIcon = () => (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <Path d="M18.5489 0.939645C19.151 1.52543 19.151 2.47518 18.5489 3.06097L9.36108 12.0003L18.5489 20.9396C19.151 21.5254 19.151 22.4752 18.5489 23.061C17.9469 23.6468 16.9707 23.6468 16.3686 23.061L5.00049 12.0003L16.3686 0.939645C16.9707 0.353859 17.9469 0.353859 18.5489 0.939645Z" fill="#730d83" />
    </Svg>
);

const ResultadoDil = ({ route, navigation }) => {
    useLogScreen('ResultadoDil');
    const { resultado } = route.params || {};

    console.log('Resultado DIL:', resultado);
    
    const estimativa = resultado?.resultado;

    // Helpers de moeda (R$) — sem centavos
    function formatCurrencyBR(value = 0) {
        const n = Math.round(value || 0);
        try {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(n);
        } catch {
            // Fallback simples com separador de milhar
            const v = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return `R$ ${v}`;
        }
    }
    function parseBRLCurrencyToNumber(text = '') {
        // Mantém apenas dígitos e interpreta como valor inteiro (sem centavos)
        const digits = String(text).replace(/\D/g, '');
        return Number(digits || 0);
    }

    // Estado local da estimativa (para permitir edição do valor)
    const [estimativaLocal, setEstimativaLocal] = useState(estimativa || null);

    // Modal de edição do valor
    const [valorEditModalVisible, setValorEditModalVisible] = useState(false);
    const [valorEditNumero, setValorEditNumero] = useState(
        typeof estimativa?.valor_estimado === 'number' ? estimativa.valor_estimado : 0
    );
    const [valorEditTexto, setValorEditTexto] = useState(formatCurrencyBR(
        typeof estimativa?.valor_estimado === 'number' ? estimativa.valor_estimado : 0
    ));

    // Guarda o valor estimado original para o payload (não muda ao editar)
    const valorEstimadoOriginalRef = useRef(
        typeof estimativa?.valor_estimado === 'number' ? estimativa.valor_estimado : 0
    );

    // Loading de geração de laudo
    const [gerandoLaudo, setGerandoLaudo] = useState(false);

    useEffect(() => {
        // Se chegar um novo resultado via rota, sincroniza estados
        if (typeof estimativa?.valor_estimado === 'number') {
            setEstimativaLocal(estimativa);
            setValorEditNumero(estimativa.valor_estimado);
            setValorEditTexto(formatCurrencyBR(estimativa.valor_estimado));
            valorEstimadoOriginalRef.current = estimativa.valor_estimado; // +++ atualiza original
        }
    }, [estimativa]);

    const onChangeValorText = (text) => {
        const number = parseBRLCurrencyToNumber(text);
        setValorEditNumero(number);
        setValorEditTexto(formatCurrencyBR(number));
    };

    const abrirModalEdicao = () => setValorEditModalVisible(true);
    const fecharModalEdicao = () => setValorEditModalVisible(false);

    const confirmarEdicao = () => {
        if (!Number.isFinite(valorEditNumero) || valorEditNumero <= 0) {
            Alert.alert('Valor inválido', 'Informe um valor maior que zero.');
            return;
        }
        setEstimativaLocal((prev) => {
            const novo = {
                ...(prev || {}),
                valor_estimado: valorEditNumero,
                formatado_ptbr: {
                    ...(prev?.formatado_ptbr || {}),
                    valor_estimado: formatCurrencyBR(valorEditNumero),
                },
            };
            return novo;
        });
        setValorEditModalVisible(false);
    };

    // Preço formatado com base no estado local
    const precoFormatado =
        estimativaLocal?.formatado_ptbr?.valor_estimado ??
        (typeof estimativaLocal?.valor_estimado === 'number'
            ? formatCurrencyBR(estimativaLocal.valor_estimado)
            : '—');

    // FIX: helpers do modal
    const altered = (estimativaLocal?.valor_estimado || 0) !== (valorEditNumero || 0);

    const adjustBy = (delta) => {
        const v = Math.max(0, (valorEditNumero || 0) + delta);
        setValorEditNumero(v);
        setValorEditTexto(formatCurrencyBR(v));
    };

    const adjustByPercent = (pct) => {
        const base = valorEditNumero || 0;
        const v = Math.max(0, Math.round(base * (1 + pct)));
        setValorEditNumero(v);
        setValorEditTexto(formatCurrencyBR(v));
    };

    // Novo: variação entre novo valor e o valor atual
    const baseValor = estimativaLocal?.valor_estimado || 0;
    const deltaValor = (valorEditNumero || 0) - baseValor;
    const deltaPct = baseValor > 0 ? deltaValor / baseValor : 0;

    const formatSignedCurrency = (n) => {
        const sign = n > 0 ? '+' : n < 0 ? '-' : '';
        return `${sign}${formatCurrencyBR(Math.abs(n))}`;
    };
    const formatSignedPercent = (ratio) => {
        const pct = Math.round((ratio || 0) * 100);
        const sign = pct > 0 ? '+' : pct < 0 ? '-' : '';
        return `${sign}${Math.abs(pct)}%`;
    };

    // Verifica retorno de amostra insuficiente (ok === false)
    const isErroAmostra = resultado?.ok === false;

    // Responsivo: dimensões do modal (corrige modalCardDynamic is not defined)
    const { width: winW, height: winH } = useWindowDimensions();
    const isLandscape = winW > winH;
    const isTablet = Math.min(winW, winH) >= 768;
    const modalCardDynamic = {
        width: Math.min(isTablet ? 600 : winW * 0.92, 640),
        maxHeight: winH * (isLandscape ? 0.9 : 0.85),
        padding: Math.max(12, Math.min(16, winW * 0.04)),
    };

    const handleBaixarLaudo = async () => {
        try {
            setGerandoLaudo(true);

            const imovel =
                resultado?.imovel ||
                resultado?.dados_imovel ||
                resultado?.entrada ||
                resultado?.input ||
                {};

            const valorM2Number =
                typeof estimativa?.valor_m2_ponderado === 'number'
                    ? estimativa.valor_m2_ponderado
                    : typeof estimativa?.valor_m2_medio === 'number'
                    ? estimativa.valor_m2_medio
                    : undefined;

            const payload = {
                bairro: imovel.bairro ?? '',
                cidade: imovel.cidade ?? '',
                endereco: imovel.endereco ?? imovel.logradouro ?? '',
                estado_conservacao: imovel.estado_conservacao ?? imovel.estado ?? '',
                tipo: imovel.tipo ?? imovel.tipo_imovel ?? '',
                quartos: Number(imovel.quartos ?? imovel.qtd_quartos ?? 0),
                suites: Number(imovel.suites ?? imovel.qtd_suites ?? 0),
                vagas: Number(imovel.vagas ?? imovel.qtd_vagas ?? 0),
                metragem: String(imovel.metragem_param ?? imovel.area ?? imovel.metros_quadrados ?? ''),
                valor_m2_ponderado:
                    typeof valorM2Number === 'number'
                        ? formatCurrencyBR(valorM2Number)
                        : String(estimativa?.valor_m2_ponderado ?? ''),
                valor_imovel: formatCurrencyBR(estimativaLocal?.valor_estimado || 0),        // final (editado)
                valor_estimado: formatCurrencyBR(valorEstimadoOriginalRef.current || 0),     // original
            };

            const { data } = await axios.post('https://gateway-laudo.vercel.app/api/laudo/gerar', payload, {
                headers: { 'Content-Type': 'application/json' },
                timeout: 60000,
            });

            if (data?.ok && data?.docx_response) {
                const pdfUrl = data.docx_response.pdf_url;
                const pptxUrl = data.docx_response.pptx_url;
                const url = pdfUrl || pptxUrl;

                setGerandoLaudo(false);

                if (url) {
                    if (Platform.OS === 'web') {
                        try {
                            window.location.assign(url); // PWA: abre na mesma aba, sem popup
                            return;
                        } catch {}
                    }

                    const supported = await Linking.canOpenURL(url);
                    if (supported) {
                        await Linking.openURL(url);
                        return;
                    }

                    // Fallback: navega para a tela de download
                    navigation.navigate('BaixarDocumento', {
                        usuario_id: route?.params?.usuario_id,
                        emailUser: route?.params?.emailUser || resultado?.usuario?.email || '',
                        pdf_name: data.docx_response.pdf_name,
                        docx_name: data.docx_response.pptx_name,
                    });
                } else {
                    Alert.alert('Laudo gerado', 'URL do documento não encontrada.');
                }
            } else {
                Alert.alert('Erro', data?.mensagem || 'Não foi possível gerar o laudo.');
            }
        } catch (err) {
            Alert.alert('Erro', err?.response?.data?.mensagem || err?.message || 'Erro ao gerar o laudo.');
        } finally {
            setGerandoLaudo(false);
        }
    };

    return (
        <SafeAreaView style={styles.safeArea}>
            <View style={styles.headerContainer}>
                <TouchableOpacity onPress={() => navigation.goBack()} style={styles.backButton}>
                    <BackArrowIcon />
                </TouchableOpacity>
                <Text style={styles.headerTitle} allowFontScaling={false}>
                    Precificador
                </Text>
            </View>

            <View style={styles.container}>
                {isErroAmostra ? (
                    <>
                        <Ionicons
                            name="alert-circle"
                            size={width * 0.2}
                            color="#D9534F"
                            style={{ marginBottom: height * 0.03 }}
                        />
                        <Text style={styles.title} allowFontScaling={false}>
                            Não foi possível gerar o laudo
                        </Text>
                        <Text style={styles.description} allowFontScaling={false}>
                            {resultado?.mensagem ??
                                'A quantidade de amostras para a região informada é insuficiente para criar um laudo.'}
                        </Text>

                        {/* {resultado?.detalhes && (
                            <View style={styles.detailBox}>
                                <Text style={styles.detailText} allowFontScaling={false}>
                                    Metragem alvo: {String(resultado?.detalhes?.metragem_alvo ?? '—')} m²
                                </Text>
                                <Text style={styles.detailText} allowFontScaling={false}>
                                    Comparáveis usados: {String(resultado?.detalhes?.comparaveis_usados ?? '—')}
                                </Text>
                                <Text style={styles.detailText} allowFontScaling={false}>
                                    Nível da base: {String(resultado?.detalhes?.nivel_base ?? '—')}
                                </Text>
                            </View>
                        )} */}

                        {/* <View style={styles.buttonContainer}>
                            <TouchableOpacity style={styles.laterButton} onPress={() => navigation.goBack()}>
                                <Ionicons name="arrow-back" size={20} color="#730d83" style={styles.laterIcon} />
                                <Text style={styles.laterButtonText} allowFontScaling={false}>Voltar</Text>
                            </TouchableOpacity>
                        </View> */}

                        <View style={styles.buttonContainer}>
                            <TouchableOpacity style={styles.laterButton} onPress={() => navigation.navigate('Home')}>
                                <Image
                                    source={require('../../../assets/icons/home.png')}
                                    style={styles.laterIcon}
                                />
                                <Text style={styles.laterButtonText} allowFontScaling={false}>
                                    Voltar pra home
                                </Text>
                            </TouchableOpacity>
                        </View>
                    </>
                ) : (
                    <>
                        <Image
                            source={require('../../../assets/img/money.png')}
                            style={styles.image}
                            resizeMode="contain"
                        />

                        <Text style={styles.title} allowFontScaling={false}>Obrigado por realizar a sua solicitação do imóvel conosco!</Text>
                        <Text style={styles.description} allowFontScaling={false}>
                            Com base nos valores que que os imóveis similares foram negociados recentemente, nossa inteligência artificial precificou o seu imóvel no valor de:
                        </Text>
                        <Text style={[styles.price_text]} allowFontScaling={false}>{precoFormatado}</Text>
                        <View style={styles.row}>
                            <View style={styles.optionButtonsContainer}>
                                {/* Botão Ajustar Valor abre o modal */}
                                <TouchableOpacity style={styles.optionButton} onPress={abrirModalEdicao}>
                                    <Image
                                        source={require('../../../assets/icons/avaliador-roxo.png')}
                                        style={styles.optionIcon}
                                    />
                                    <View style={styles.optionTextContainer}>
                                        <Text style={styles.optionTextTitle} allowFontScaling={false}>Ajustar Valor</Text>
                                    </View>
                                </TouchableOpacity>
                                <TouchableOpacity style={styles.optionButton} onPress={handleBaixarLaudo}>
                                    <Image
                                        source={require('../../../assets/icons/download.png')}
                                        style={styles.optionIcon}
                                    />
                                    <View style={styles.optionTextContainer}>
                                        <Text style={styles.optionTextTitle} allowFontScaling={false}>Baixar Laudo (pdf)</Text>
                                    </View>
                                </TouchableOpacity>
                            </View>
                        </View>
                        <View style={styles.buttonContainer}>
                            <TouchableOpacity style={styles.laterButton} onPress={() => navigation.navigate('Home')}>
                                <Image
                                    source={require('../../../assets/icons/home.png')}
                                    style={styles.laterIcon}
                                />
                                <Text style={styles.laterButtonText} allowFontScaling={false}>
                                    Voltar pra home
                                </Text>
                            </TouchableOpacity>
                        </View>
                    </>
                )}
            </View>

            {/* Modal de edição do valor */}
            <Modal
                transparent
                visible={valorEditModalVisible}
                animationType="fade"
                onRequestClose={fecharModalEdicao}
            >
                <View style={styles.modalRoot}>
                    <TouchableWithoutFeedback onPress={fecharModalEdicao}>
                        <View style={styles.modalOverlay} />
                    </TouchableWithoutFeedback>

                    {/* +++ Evita que o teclado cubra o modal */}
                    <KeyboardAvoidingView
                        behavior={Platform.OS === 'ios' ? 'padding' : undefined}
                        keyboardVerticalOffset={Platform.select({ ios: 64, android: 0 })}
                        style={styles.modalAvoider}
                    >
                        <View style={[styles.modalCard, modalCardDynamic]}>
                            {/* Botão fechar (fixo no topo do card) */}
                            <TouchableOpacity style={styles.modalCloseBtn} onPress={fecharModalEdicao}>
                                <Ionicons name="close" size={20} color="#555" />
                            </TouchableOpacity>

                            {/* +++ Conteúdo rolável para telas pequenas */}
                            <ScrollView
                                contentContainerStyle={styles.modalCardContent}
                                keyboardShouldPersistTaps="handled"
                                showsVerticalScrollIndicator={false}
                            >
                                <Text style={styles.modalTitle} allowFontScaling={false}>Ajustar valor do laudo</Text>

                                <Text style={styles.modalSubtitle} allowFontScaling={false}>Valor atual</Text>
                                <Text style={styles.modalCurrentValue} allowFontScaling={false}>{precoFormatado}</Text>

                                <Text style={styles.modalLabel} allowFontScaling={false}>Novo valor</Text>
                                <View style={styles.inputRow}>
                                    <TextInput
                                        value={valorEditTexto}
                                        onChangeText={onChangeValorText}
                                        keyboardType="number-pad"
                                        placeholder="R$ 0"
                                        style={styles.currencyInput}
                                    />
                                    <View style={styles.stepper}>
                                        <TouchableOpacity
                                            style={styles.stepperBtn}
                                            onPress={() => adjustBy(-1000)}
                                            accessibilityLabel="Diminuir 1 mil"
                                        >
                                            <Ionicons name="remove" size={18} color="#730D83" />
                                        </TouchableOpacity>
                                        <TouchableOpacity
                                            style={styles.stepperBtn}
                                            onPress={() => adjustBy(+1000)}
                                            accessibilityLabel="Aumentar 1 mil"
                                        >
                                            <Ionicons name="add" size={18} color="#730D83" />
                                        </TouchableOpacity>
                                    </View>
                                </View>

                                {/* Novo: mostra a variação em relação ao valor atual */}
                                <View style={styles.deltaRow}>
                                    <Text
                                        style={[
                                            styles.deltaText,
                                            deltaValor > 0 ? styles.deltaUp : deltaValor < 0 ? styles.deltaDown : null,
                                        ]}
                                        allowFontScaling={false}
                                    >
                                        Variação: {formatSignedCurrency(deltaValor)} ({formatSignedPercent(deltaPct)})
                                    </Text>
                                </View>

                                {/* Ajustes rápidos em R$ */}
                                <View style={styles.quickRow}>
                                    <TouchableOpacity style={styles.chipBtn} onPress={() => adjustBy(-10000)}>
                                        <Text style={styles.chipBtnText} allowFontScaling={false}>-10k</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.chipBtn} onPress={() => adjustBy(-5000)}>
                                        <Text style={styles.chipBtnText} allowFontScaling={false}>-5k</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.chipBtn} onPress={() => adjustBy(+5000)}>
                                        <Text style={styles.chipBtnText} allowFontScaling={false}>+5k</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.chipBtn} onPress={() => adjustBy(+10000)}>
                                        <Text style={styles.chipBtnText} allowFontScaling={false}>+10k</Text>
                                    </TouchableOpacity>
                                </View>

                                {/* Ajustes rápidos em % */}
                                <Text style={styles.modalLabel} allowFontScaling={false}>Variação percentual</Text>
                                <View style={styles.quickRow}>
                                    <TouchableOpacity style={styles.chipBtn} onPress={() => adjustByPercent(-0.05)}>
                                        <Text style={styles.chipBtnText} allowFontScaling={false}>-5%</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.chipBtn} onPress={() => adjustByPercent(-0.01)}>
                                        <Text style={styles.chipBtnText} allowFontScaling={false}>-1%</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.chipBtn} onPress={() => adjustByPercent(+0.01)}>
                                        <Text style={styles.chipBtnText} allowFontScaling={false}>+1%</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.chipBtn} onPress={() => adjustByPercent(+0.05)}>
                                        <Text style={styles.chipBtnText} allowFontScaling={false}>+5%</Text>
                                    </TouchableOpacity>
                                </View>

                                <Text style={styles.modalHint} allowFontScaling={false}>
                                    Dica: use os botões para ajustar rapidamente por valor ou porcentagem.
                                </Text>

                                <View style={styles.modalButtons}>
                                    <TouchableOpacity style={[styles.modalButton, styles.modalCancel]} onPress={fecharModalEdicao}>
                                        <Text style={styles.modalButtonTextCancel} allowFontScaling={false}>Cancelar</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity
                                        style={[styles.modalButton, styles.modalConfirm, !altered && styles.modalConfirmDisabled]}
                                        onPress={confirmarEdicao}
                                        disabled={!altered}
                                    >
                                        <Text style={styles.modalButtonTextConfirm} allowFontScaling={false}>Salvar</Text>
                                    </TouchableOpacity>
                                </View>
                            </ScrollView>
                        </View>
                    </KeyboardAvoidingView>
                </View>
            </Modal>

            {/* Loading de geração do laudo */}
            <Modal
                transparent
                visible={gerandoLaudo}
                animationType="fade"
                onRequestClose={() => {}}
            >
                <View style={styles.modalRoot}>
                    <View style={styles.modalOverlay} />
                    <View style={styles.loadingCard}>
                        <ActivityIndicator size="large" color="#730D83" />
                        <Text style={styles.loadingText} allowFontScaling={false}>
                            Criando laudo... Isso pode levar alguns segundos.
                        </Text>
                    </View>
                </View>
            </Modal>
        </SafeAreaView>
    );
};


const styles = {
    // header voltar 
    headerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: width * 0.05,
        paddingVertical: height * 0.02,
        backgroundColor: '#F5F5F5',
    },
    headerTitle: {
        fontSize: width * 0.04,
        fontWeight: 'bold',
        color: '#1F2024',
        textAlign: 'center',
        // fontFamily: 'Nunito_700Bold',
    },
    backButton: {
        position: 'absolute',
        left: 20,
    },
    // fim header     
    // safe area
    safeArea: {
        flex: 1,
        backgroundColor: '#F5F5F5',
    },
    // fim safe area
    // 
    container: {
        flex: 1,
        backgroundColor: '#F4F4F4',
        paddingHorizontal: width * 0.05,
        paddingTop: Platform.select({
            ios: height * 0.05,
            android: height * 0.05,
        }),
        alignItems: 'center',
    },
    image: {
        width: width * 0.7, // Aumentado para 70% da largura da tela
        height: height * 0.4, // Aumentado para 40% da altura da tela
        marginBottom: height * 0.03, // Ajustei o espaço inferior para a imagem
    },
    title: {
        fontSize: Platform.select({
            ios: width * 0.045,
            android: width * 0.042,
        }),
        fontWeight: 'bold',
        color: '#1F2024',
        // fontFamily: 'Nunito_700Bold',
        textAlign: 'center',
        marginBottom: height * 0.01, // Ajuste de margem inferior para o título
        marginHorizontal: width * 0.05, // Margem lateral para alinhar com a imagem
    },
    description: {
        fontSize: Platform.select({
            ios: width * 0.035,
            android: width * 0.035,
        }),
        color: '#2F3036',
        textAlign: 'justify',
        // fontFamily: 'Nunito_700Bold',
        marginBottom: height * 0.03,
        marginHorizontal: width * 0.1,
    },
    price_text: {
        color: '#730D83',
        fontSize: width * 0.05,
        marginTop: height * 0.02,
        fontWeight: 'bold',
        // fontFamily: 'Nunito_700Bold',
    },
    // 
    row: {
        marginBottom: 20,
        width: '100%',
    },

    laterButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    laterIcon: {
        width: 20,
        height: 20,
        marginRight: 8,
    },
    laterButtonText: {
        color: '#730d83',
        fontSize: Platform.select({ ios: width * 0.04, android: width * 0.04 }), // Ajuste no tamanho da fonte
        fontWeight: '600',
    },
    // input que abre     

    optionButtonsContainer: {
        width: '100%',
        marginTop: 20,
        alignItems: 'center',
    },
    optionButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: '#F5F5F5',
        borderColor: '#D3D3D3',
        borderWidth: 1,
        borderRadius: 10,
        width: '100%',
        padding: 15,
        marginBottom: 10,
    },
    optionButtonSecundary: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: '#730d83',
        borderColor: '#D3D3D3',
        borderWidth: 1,
        borderRadius: 10,
        width: '100%',
        padding: 15,
        marginBottom: 10,
    },
    optionIcon: {
        width: 24,
        height: 24,
        marginRight: 15,
        // tintColor: '#730d83', // Deixa a cor dos ícones laranja
    },
    optionIconSecundary: {
        width: 24,
        height: 24,
        marginRight: 15,
        tintColor: '#FFF', // Deixa a cor dos ícones laranja
    },
    optionTextContainer: {
        flexDirection: 'column',
    },
    optionTextTitle: {
        fontSize: width * 0.03,
        fontWeight: 'bold',        
        color: '#1F2024',
    },
    optionTextTitleSecundary: {
        
        fontSize: width * 0.03,
        fontWeight: 'bold',
        color: '#FFF',
    },
    optionTextSubtitle: {
        fontSize: width * 0.03,
        color: '#7A7A7A',
    },

    // Novo: container de botões (se ainda não existir)
    buttonContainer: {
        width: '100%',
        marginTop: 10,
        alignItems: 'center',
    },

    // Novo: caixa de detalhes do erro
    detailBox: {
        width: '100%',
        backgroundColor: '#FFFFFF',
        borderColor: '#E6E6E6',
        borderWidth: 1,
        borderRadius: 8,
        padding: 12,
        marginTop: 10,
    },
    detailText: {
        fontSize: width * 0.03,
        color: '#2F3036',
        marginBottom: 4,
    },

    // Novo: estilos do modal
    modalRoot: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalOverlay: {
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
    },
    // +++ container para centralizar o card com o teclado aberto
    modalAvoider: {
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
    },
    modalCard: {
        width: '88%',
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        padding: 16,
        elevation: 6,
        shadowColor: '#000',
        shadowOpacity: 0.2,
        shadowRadius: 8,
        shadowOffset: { width: 0, height: 2 },
        position: 'relative',
        // maxHeight agora é aplicado dinamicamente via modalCardDynamic
    },
    // +++ espaçamento interno do conteúdo rolável
    modalCardContent: {
        paddingTop: 4,
        paddingBottom: 8,
    },
    modalCloseBtn: {
        position: 'absolute',
        top: 10,
        right: 10,
        padding: 6,
        borderRadius: 14,
    },
    modalTitle: {
        fontSize: width * 0.045,
        fontWeight: 'bold',
        color: '#1F2024',
        marginBottom: 8,
        textAlign: 'center',
    },
    modalSubtitle: {
        fontSize: width * 0.03,
        color: '#7A7A7A',
        marginTop: 6,
    },
    modalCurrentValue: {
        fontSize: width * 0.045,
        fontWeight: 'bold',
        color: '#730D83',
        marginBottom: 12,
    },
    modalLabel: {
        fontSize: width * 0.032,
        color: '#1F2024',
        marginBottom: 6,
        marginTop: 4,
    },
    inputRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
    },
    currencyInput: {
        flex: 1,
        backgroundColor: '#F5F5F5',
        borderColor: '#D3D3D3',
        borderWidth: 1,
        borderRadius: 8,
        paddingHorizontal: 12,
        paddingVertical: Platform.select({ ios: 12, android: 8 }),
        fontSize: width * 0.04,
        color: '#1F2024',
        textAlign: 'left',
    },
    stepper: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    stepperBtn: {
        backgroundColor: '#EEE0F0',
        paddingHorizontal: 10,
        paddingVertical: 8,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#D3D3D3',
    },
    stepperBtnText: {
        color: '#730D83',
        fontWeight: '600',
        fontSize: width * 0.03,
    },
    modalButtons: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: 16,
        gap: 10,
    },
    modalButton: {
        paddingHorizontal: 16,
        paddingVertical: 10,
        borderRadius: 8,
        borderWidth: 1,
    },
    modalCancel: {
        backgroundColor: '#FFFFFF',
        borderColor: '#D3D3D3',
    },
    modalConfirm: {
        backgroundColor: '#730D83',
        borderColor: '#730D83',
    },
    modalButtonTextCancel: {
        color: '#1F2024',
        fontWeight: '600',
    },
    modalButtonTextConfirm: {
        color: '#FFFFFF',
        fontWeight: '700',
    },
    quickRow: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
        marginTop: 10,
        marginBottom: 6,
    },
    chipBtn: {
        paddingHorizontal: 12,
        paddingVertical: 8,
        borderRadius: 16,
        backgroundColor: '#EEE0F0',
        borderWidth: 1,
        borderColor: '#D3D3D3',
    },
    chipBtnText: {
        color: '#730D83',
        fontWeight: '600',
        fontSize: width * 0.03,
    },
    modalHint: {
        marginTop: 6,
        color: '#7A7A7A',
        fontSize: width * 0.028,
    },
    modalConfirmDisabled: {
        opacity: 0.6,
    },

    // Novo: estilos da variação
    deltaRow: {
        marginTop: 8,
        marginBottom: 4,
    },
    deltaText: {
        fontSize: width * 0.032,
        fontWeight: '600',
        color: '#7A7A7A',
    },
    deltaUp: {
        color: '#2E7D32', // verde
    },
    deltaDown: {
        color: '#C62828', // vermelho
    },

    // Novo: estilos do loading
    loadingCard: {
        width: '80%',
        maxWidth: 420,
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        padding: 20,
        alignItems: 'center',
        justifyContent: 'center',
        elevation: 6,
        shadowColor: '#000',
        shadowOpacity: 0.2,
        shadowRadius: 8,
        shadowOffset: { width: 0, height: 2 },
    },
    loadingText: {
        marginTop: 12,
        fontSize: width * 0.032,
        color: '#1F2024',
        textAlign: 'center',
    },
};

export default ResultadoDil;